/**
 * Show a list of subscriptions to an app or service.  Used in the AppEdit and ServiceEdit pages
 */
import React, { Component } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { QueryRenderer } from 'react-relay';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import { FormControlLabel, Grid, Switch, TablePagination } from '@mui/material';
import SubscriptionsAcrossCustomerList from './SubscriptionsAcrossCustomerList';
import LoadingSpinner from '../ui/LoadingSpinner';
import ServerError from '../ui/ServerError';
import SearchField from '../ui/SearchField';

const abEnvironment = new AbEnvironment();

const SubscriptionsAcrossCustomerQuery = graphql`
query SubscriptionsAcrossCustomerQuery($resellerAccountId: UUID, $appId: UUID, $customerName: String, $pOrder: Int, $actOnly: Int, $first: Int, $offset: Int) {
  getsubscriptionchargesacrosscustomer(resellerAccountId: $resellerAccountId, appId: $appId, customerName: $customerName, paymentOrder: $pOrder, activeOnly: $actOnly, first: $first, offset: $offset) {
    totalCount
    ...SubscriptionsAcrossCustomerList_sl
  }
}
`;

const styleSheet = theme => ({
    root: {
      flexGrow: 1,
      // marginTop: -32,
    },
    flex: {
      flex: 1,
    }
});

class SubscriptionsAcrossCustomer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      customerAccountId: this.props.customerAccountId,
      customerName:           '', 
      activeOnly:        0,
      page:              0,
      rowsPerPage:       10
    };  
  }


  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
      page: 0,
    });
  };

  handleChangePage = (event, page) => {
    this.setState({page: page});
  }

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value, page : 0});
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  setParentTab = (tv) => {
    if (this.props.setTabVal) {
      this.props.setTabVal(tv);
    }
  }

  goToFunding = () => {
    if (this.props.setTabVal) {
      this.props.setTabVal(1);
    }  else if (this.props.pscount != null && this.props.pscount === 0) {
      // Go to the funding page
      this.props.history.push("/fundingsources");
    }
  }

  render() {
    const { isAuthenticated, isAuthenticatedReseller, needAssent, logError } = this.props.auth;
    const classes = this.props.classes;

    let myAccountId = abEnvironment.getUserAttribute("a_id");

    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    }    
    let theCustomerSearch = '%';
    if (this.state.customerName !== '')
    {
      theCustomerSearch = '%' + this.state.customerName + '%';
    }

    // Determine the offset
    let offset = 0;
    if (this.state.page > 0)
    {
      offset = this.state.page * this.state.rowsPerPage
    }
    let first = this.state.rowsPerPage;

    let paymentOrder = null;

    let activeOnly = null;
    if (this.state.activeOnly === 0)
    {
      //user wants to only see active subscriptions
      activeOnly = 1;
    }

    // let subCreateLink = "subscriptioncreate?appId=" + this.props.appId;

    if (isAuthenticatedReseller())
    {

      return (
        <div className={classes.root}>

          {/*<Grid container spacing={2} direction="row" justifyContent="flex-start">
            <Grid item xs={12} style={{marginTop: 16, marginBottom: 16}}>
              <Button className={classes.topButton}
                  color="primary"
                  variant="contained"
                  onClick={() => {
                    this.goTo(subCreateLink); 
                  }}>
                <Add/>&nbsp;Buy Subscription
              </Button>      
            </Grid>
          </Grid>*/}

          <Grid container spacing={0} direction="row" >


            <Grid item xs={10} sm={11}>
              <Grid container spacing={2} direction="row" >

                <Grid item>
                  <SearchField
                      id="customerName"
                      label="Search by customer name "
                      value={this.state.customerName}
                      onChange={this.handleChange('customerName')}
                    />

                </Grid>

                <Grid item>
                  <FormControlLabel style={{marginTop: '16px'}}
                    control={
                      <Switch
                        checked={this.state.activeOnly === 0}
                        onChange={(e, checked) => {
                          if (checked) {
                            this.setState({ activeOnly: 0, page: 0});
                          } else {
                            this.setState({ activeOnly: 1, page: 0});
                          }
                        }}
                      />
                    }
                    label="Only show active subscriptions"
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>


          <QueryRenderer
            environment={abEnvironment.getEnvironment()}
            query={SubscriptionsAcrossCustomerQuery}
            variables={{resellerAccountId: myAccountId,
                        appId: this.props.appId,
                        customerName: theCustomerSearch,
                        pOrder: paymentOrder,
                        actOnly: activeOnly,
                        first: first,
                        offset: offset}}
            render={({error, props})=> {
              if (error) {
                logError(error.message);
                return (
                  <ServerError/>
                );
              } else if (props) {
                // Determine offset information
                let totalCount = props.getsubscriptionchargesacrosscustomer.totalCount;
                
                return (
                  <div>
                    <SubscriptionsAcrossCustomerList sl={props.getsubscriptionchargesacrosscustomer} 
                                      auth={this.props.auth}
                                      history={this.props.history}
                                      loginLink={this.props.loginLink} 
                                      fromAppEdit={this.props.fromAppEdit}/>
                    <div style={{marginTop: '10px'}}>
                      <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={totalCount}
                        rowsPerPage={this.state.rowsPerPage}
                        page={this.state.page}
                        backIconButtonProps={{
                          'aria-label': 'Previous Page',
                        }}
                        nextIconButtonProps={{
                          'aria-label': 'Next Page',
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                      />                        
                    </div>
                  </div>
                )
              }
              return (
                <LoadingSpinner />
              );
            }}
          />
        </div>
      );
    } else {
      return (
        <Redirect to='/home' />
      );
    }
  }
}
  
SubscriptionsAcrossCustomer.propTypes = {
  classes: PropTypes.object.isRequired,
};
  
export default withStyles(styleSheet)(SubscriptionsAcrossCustomer);
